import { RewardAmountType } from './RewardAmountType';

export type CampaignRewardTarget = {
  targetName: string;
  targetId: number;
};

export type CampaignTarget = {
  targetType: string;
  targets: CampaignRewardTarget[];
};

export type CampaignTargetAudience = {
  audienceName: string;
  audienceId: string;
};

export type CampaignTargetFilter = {
  targetType: string;
  targets: CampaignRewardTarget[];
};

export type CampaignTargetingCriterion = {
  targetActionType: string;
  targetFilters: CampaignTargetFilter[];
};

export type CampaignReward = {
  campaignBudgetAmountRemaining: number;
  campaignBudgetAmountTotal: number;
  campaignId: string;
  campaignDocumentId: string;
  campaignType: string;
  campaignStatus: string;
  campaignName: string;
  createdBy: string;
  startDate: string;
  endDate: string;
  createdTime: string;
  rewardAmount: number;
  rewardCurrency: string;
  updatedBy: string;
  updatedTime: string;
  target: CampaignTarget;
  brandId: number;
  targetingType: string;
  targetAudiences: CampaignTargetAudience[];
  targetingCriteria: CampaignTargetingCriterion[];
  '@campaignRewardsUpdatedTime'?: string;
};

export type BrandCampaignRewardAggregate = {
  amount?: number;
  count?: number;
  maxAmount?: number;
  maxAmountType?: RewardAmountType;
};

export type BrandCampaignRewardsAggregateSummary = {
  content?: BrandCampaignRewardAggregate;
  survey?: BrandCampaignRewardAggregate;
  purchase?: BrandCampaignRewardAggregate;
  affiliate?: BrandCampaignRewardAggregate;
  dailyDeal?: BrandCampaignRewardAggregate;
};

export type BrandClub = {
  brandclubId: string;
  isInternalCompany?: boolean;
  imageUrl: string;
  name: string;
  brandIds: Set<number>;
  brandId: number;
  searchScore?: number;
  totalRewardAmount?: number;
  hasRewards?: boolean;
  isMember?: boolean;
  rewardAmount?: number;
  campaignRewards?: CampaignReward[];
  lifetimePayout?: number;
  availableSurveyRewardAmount?: number;
  availableContentRewardAmount?: number;
  availableCampaignRewardsSummary?: BrandCampaignRewardsAggregateSummary;
  nextUnlockedRewardAmount?: number;
};

export enum CampaignType {
  MembershipRewardCampaign = 'promoteBrandClubRewardCampaign',
  PurchaseRewardCampaign = 'purchaseRewardCampaign',
  SurveyRewardCampaign = 'surveyRewardCampaign',
  DailyDealsRewardCampaign = 'limitedTimePurchaseRewardCampaign',
  RatingCampaign = 'reviewRewardCampaign',
  AffiliateRewardCampaign = 'affiliateLinkCampaign',
  ContentRewardCampaign = 'contentRewardCampaign',
  ReferralRewardCampaign = 'referralRewardCampaign',
  RetailerConnectRewardCampaign = 'retailerConnectRewardCampaign',
}

export enum BrandclubEntityType {
  Audience = 'audience',
  Brand = 'brand',
  Category = 'category',
  Subcategory = 'subCategory',
  CustomCategoryGroup = 'customCategoryGroup',
  Campaign = 'campaign',
  CompanyDivision = 'companyDivision',
  Customer = 'customer',
  Product = 'product',
  Reward = 'reward',
  Profile = 'profile',
}
